// 接口地址
export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;

// 测试本地模拟接口地址
// export const API_LOCAL_BASE_URL = "http://bs.admin.hanmeiguan.com/";
export const API_LOCAL_BASE_URL = "http://10.23.1.18:8080/";


// 项目名称
export const PROJECT_NAME = 'BSG 行政管理系统';

// 不显示侧栏的路由
export const HIDE_SIDEBARS = [];

// 不显示页脚的路由
export const HIDE_FOOTERS = [
  '/system/dictionary',
  '/system/organization',
  '/form/advanced'
];
// 页签同路由不同参数可重复打开的路由
export const REPEATABLE_TABS = [];

// 不需要登录的路由
export const WHITE_LIST = ['/login', '/sso/callback', '/login-success', '/forget', '/preview/customer-ops-dashboard'];

// 开启 KeepAlive 后仍然不需要缓存的路由地址
export const KEEP_ALIVE_EXCLUDES = [];

const XINGZHENG_MENUS = [
  {
    title: '数据看板',
    path: '/xingzheng/dashboard',
    component: 'xingzheng/index',
    icon: 'el-icon-house'
  },
  {
    title: '员工管理',
    path: '/xingzheng/employees',
    component: 'xingzheng/index',
    icon: 'el-icon-user'
  },
  {
    title: '周年纪念',
    path: '/xingzheng/anniversary',
    component: 'xingzheng/index',
    icon: 'el-icon-medal'
  },
  {
    title: '生日管理',
    path: '/xingzheng/birthday',
    component: 'xingzheng/index',
    icon: 'el-icon-present'
  },
  {
    title: '离职管理',
    path: '/xingzheng/attrition',
    component: 'xingzheng/index',
    icon: 'el-icon-switch-button'
  },
  {
    title: 'BSG 大事记',
    path: '/xingzheng/events',
    component: 'xingzheng/index',
    icon: 'el-icon-s-flag'
  },
  {
    title: 'BSG 照片集',
    path: '/xingzheng/album',
    component: 'xingzheng/index',
    icon: 'el-icon-picture-outline'
  },
  {
    title: '安全检查',
    path: '/xingzheng/safety',
    component: 'xingzheng/index',
    icon: 'el-icon-warning-outline'
  },
  {
    title: '出差记录',
    path: '/xingzheng/travel',
    component: 'xingzheng/index',
    icon: 'el-icon-position'
  }
];

// 行政管理按设计稿固定左侧菜单，不再使用后端动态菜单
export const USER_MENUS = XINGZHENG_MENUS;

// 首页名称, 为空则取第一个菜单的名称
export const HOME_TITLE = undefined;

// 首页路径
export const HOME_PATH = '/xingzheng/dashboard';

// 外层布局的路由地址
export const LAYOUT_PATH = '/';

// 刷新路由的路由地址
export const REDIRECT_PATH = '/redirect';

// 开启页签栏是否缓存组件
//export const TAB_KEEP_ALIVE = process.env.NODE_ENV !== 'development';
export const TAB_KEEP_ALIVE = true;

// token 传递的 header 名称
export const TOKEN_HEADER_NAME = 'Authorization';

// token 存储的名称
export const TOKEN_STORE_NAME = 'bsg_access_token';

// 主题配置存储的名称
export const THEME_STORE_NAME = 'theme';

// i18n 缓存的名称
export const I18N_CACHE_NAME = 'i18n-lang';

// 是否开启国际化功能
export const I18N_ENABLE = false;

// 高德地图 key , 自带的只能用于测试, 正式项目请自行到高德地图官网申请 key
export const MAP_KEY = 'd10f48dae12c9119d168125fbe40caa6';

// 授权码, 自带的只能用于演示, 正式项目请更换为自己的授权码
export const LICENSE_CODE =
  'dk9mcwJyetRWQlxWRiojIqJWdzJCLi4Wa5UzN2ojI0NWZxYkI6ICZpJCLiwiIWF3Yo5kZ6Iibvl2cyVmdQfiATMuEjI0NW==';
